import React from "react";
import CNCLogo from "@/assets/icons/clickNcollect.svg?react";
import NoExchangeLogo from "@/assets/icons/no-exchange.svg?react";
import { CNCBadgeProps, CNCBadgeTypes } from "./types";
import { cn } from "@/lib/tailwind";

const CNCBadge = ({ className, badges }: CNCBadgeProps) => {
  const Logos: Record<CNCBadgeTypes, React.ReactNode> = {
    ClickNCollect: <CNCLogo className="w-3 md:w-[13px]" />,
    NotReturnable: <NoExchangeLogo className="w-3 md:w-[13px]" />,
  };

  return (
    badges?.length > 0 && (
      <div className={cn("flex flex-wrap gap-2", className)}>
        {badges?.map((item, idx) => (
          <div
            key={idx}
            className="inline-flex items-start gap-1 bg-tertiary-3 px-2 py-1 md:px-3"
            title={item?.label}
          >
            <span className="mt-[2px]">{Logos[item?.badge]}</span>
            <span className="text-xs">{item?.label}</span>
          </div>
        ))}
      </div>
    )
  );
};

export default CNCBadge;
